"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.MSA_TYPE_MAPPER = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var interfaces_1 = require("@hudled/interfaces");
var AvatarGroup_1 = __importDefault(require("atomicComponents/atoms/Avatar/AvatarGroup"));
var LogoImg_1 = __importDefault(require("atomicComponents/atoms/Logo/LogoImg"));
var LogoAndName_1 = __importDefault(require("atomicComponents/molecules/Image/LogoAndName"));
var ButtonSec_1 = require("components/Buttons/ButtonSec");
var ButtonsHolder_1 = __importDefault(require("components/Buttons/ButtonsHolder"));
var ToggleButton_1 = __importDefault(require("components/Buttons/ToggleButton"));
var OptimiseStatusIcon_1 = __importDefault(require("components/Icons/OptimiseStatusIcon"));
var LoadingSpinner_1 = __importDefault(require("components/LoadingSpinner"));
var Money_1 = __importDefault(require("components/Money"));
var BodyCell_1 = __importDefault(require("containers/MyStack/styles/BodyCell"));
var Text_1 = __importDefault(require("shared/components/Text"));
var fieldProcessors_1 = require("utils/fieldProcessors");
var hooks_1 = require("utils/hooks");
var MSA_TYPE2ACTION = (_a = {},
    // [RECOMMENDATIONS_TYPE.PAPR]: 'Activate',
    // [RECOMMENDATIONS_TYPE.USUB]: 'Cancel',
    // [RECOMMENDATIONS_TYPE.M2Y]: 'Change',
    _a[interfaces_1.RECOMMENDATIONS_TYPE.FX] = 'Reduce',
    // [RECOMMENDATIONS_TYPE.DORM]: 'Remove',
    // [RECOMMENDATIONS_TYPE.ALT]: 'Replace with',
    _a[interfaces_1.RECOMMENDATIONS_TYPE.NEGOT] = 'Negotiate',
    _a);
exports.MSA_TYPE_MAPPER = (_b = {},
    // [RECOMMENDATIONS_TYPE.PAPR]: 'Partnership Price',
    // [RECOMMENDATIONS_TYPE.USUB]: 'Unused app',
    // [RECOMMENDATIONS_TYPE.M2Y]: 'Billing Plan',
    _b[interfaces_1.RECOMMENDATIONS_TYPE.FX] = 'Forex Costs',
    // [RECOMMENDATIONS_TYPE.DORM]: 'Dormant Users',
    // [RECOMMENDATIONS_TYPE.ALT]: 'Alternative Apps',
    _b[interfaces_1.RECOMMENDATIONS_TYPE.NEGOT] = 'Better Pricing',
    _b);
var OptimiseRow = function (_a) {
    var _b;
    var recommendation = _a.recommendation, openView = _a.openView, showServiceStat = _a.showServiceStat, isAdmin = _a.isAdmin;
    var service = recommendation.service;
    var _c = __read((0, hooks_1.useSubmitter)('recommendations', recommendation.id), 2), updateRecommendation = _c[0], isSaving = _c[1];
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(BodyCell_1.default, __assign({ colSpan: 2, onClick: openView, padding: "none" }, { children: recommendation.status && (0, jsx_runtime_1.jsx)(OptimiseStatusIcon_1.default, { status: recommendation.status }) })), (0, jsx_runtime_1.jsxs)(BodyCell_1.default, __assign({ onClick: openView, colSpan: 4, padding: "none", sx: { position: 'relative' } }, { children: [(0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: "caption", id: "showOnHover", sx: { position: 'absolute', top: 20, fontSize: 12 } }, { children: MSA_TYPE2ACTION[recommendation.type] })), (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)("span", { children: exports.MSA_TYPE_MAPPER[recommendation.type] }) })] })), (0, jsx_runtime_1.jsx)(BodyCell_1.default, __assign({ colSpan: 9, onClick: openView, padding: "none", align: "center" }, { children: recommendation.potentialSavings && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("span", { children: (0, jsx_runtime_1.jsx)(Money_1.default, { amount: recommendation.potentialSavings, isRounded: true }) }), (0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: 1, component: "span", sx: { color: 'success.main', ml: 1 }, id: "showOnHover" }, { children: (0, fieldProcessors_1.percentage)(recommendation.potentialSavingsPercentage) })), !showServiceStat ? ' Savings / yr' : ''] })) })), showServiceStat && ((0, jsx_runtime_1.jsx)(BodyCell_1.default, __assign({ colSpan: 8, onClick: openView, padding: "none", align: "center" }, { children: [interfaces_1.RECOMMENDATIONS_TYPE.FX, interfaces_1.RECOMMENDATIONS_TYPE.NEGOT].includes(recommendation.type)
                    ? ((0, jsx_runtime_1.jsx)(AvatarGroup_1.default, __assign({ max: 8 }, { children: (_b = recommendation.multiServiceMeta) === null || _b === void 0 ? void 0 : _b.appLogos.map(function (logo) { return (0, jsx_runtime_1.jsx)(LogoImg_1.default, { src: logo }, logo); }) })))
                    : service && (0, jsx_runtime_1.jsx)(LogoAndName_1.default, { brand: service, size: "sm" }) }))), (0, jsx_runtime_1.jsx)(BodyCell_1.default, __assign({ colSpan: 2, onClick: openView, padding: "none", id: "showOnHover" }, { children: (0, jsx_runtime_1.jsx)(ButtonsHolder_1.default, { children: (0, jsx_runtime_1.jsx)(ButtonSec_1.ButtonHybridSm, __assign({ onClick: openView, noMargin: true }, { children: showServiceStat ? '+' : 'View Details' })) }) })), isAdmin && ((0, jsx_runtime_1.jsx)(BodyCell_1.default, __assign({ colSpan: 2, padding: "none", align: "center" }, { children: isSaving
                    ? (0, jsx_runtime_1.jsx)(LoadingSpinner_1.default, {})
                    : ((0, jsx_runtime_1.jsx)(ToggleButton_1.default, { isSoftDelete: recommendation.isSoftDelete, toggleAction: function () { return updateRecommendation({ isSoftDelete: !recommendation.isSoftDelete }); } })) })))] }));
};
exports.default = OptimiseRow;
